"use client";

/**
 * @file Client-side providers for the application.
 *
 * Wraps children with React Query provider for data fetching.
 */

import type { FC, ReactNode } from "react";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";

/**
 * Root providers component for client-side context.
 *
 * Creates a new QueryClient instance per component mount to avoid
 * sharing state between requests in SSR.
 */
export const Providers: FC<{ children: ReactNode }> = ({ children }) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: 1,
            staleTime: 60_000,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
